import React, { useState, useEffect, useCallback, useRef } from 'react';
import api from '../../services/api';
import { RIESGOS } from './catalogos';
import { parsearNomina, ORDEN_DEFECTO } from './nominaParser';

/* ── helpers ─────────────────────────────────────────────── */
const msg = e => (e && e.response && e.response.data && e.response.data.error) || (e && e.message) || 'Error inesperado';
const fmtFecha = f => (f ? String(f).slice(0, 10).split('-').reverse().join('/') : '—');
const fmtMoney = v => (v === null || v === undefined || v === '' ? '—' : '$ ' + Number(v).toFixed(2));
const iniciales = (a, n) => ((a || '').trim()[0] || '') + ((n || '').trim()[0] || '');
const hoyISO = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };   // fecha local, no UTC

/* ── CSS (mismo lenguaje visual que Pacientes: tarjetas, tabs, tablas, paginador) ── */
const css = `
.mo-kpis{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-bottom:16px;}
.mo-kpi{background:var(--surface);border-radius:10px;border:1px solid var(--border);padding:14px 16px;}
.mo-kpi-l{font-size:10.5px;text-transform:uppercase;font-weight:700;color:var(--text3);letter-spacing:.4px;}
.mo-kpi-v{font-size:24px;font-weight:800;color:var(--navy);margin:4px 0 2px;}
.mo-kpi-s{font-size:10.5px;font-weight:700;color:var(--navy);}
.mo-card{background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;}
.mo-head{background:#fff;padding:14px 18px;display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap;border-bottom:1px solid var(--border);}
.mo-head-l{display:flex;align-items:center;gap:10px;min-width:0;flex-wrap:wrap;}
.mo-head-r{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
.mo-title{font-size:13px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--navy);}
.mo-title2{font-size:14px;font-weight:700;color:var(--text);}
.mo-sub{font-size:11px;color:var(--text3);margin-top:2px;}
.mo-toolbar{padding:14px 18px;background:#fff;border-bottom:1px solid var(--border);display:flex;align-items:center;gap:10px;flex-wrap:wrap;}
.mo-table thead tr{background:var(--blue-lt);}
.mo-table thead th{padding:13px 16px;font-size:10.5px;font-weight:700;letter-spacing:.5px;text-transform:uppercase;color:var(--navy);border:none;border-bottom:2px solid var(--border);white-space:nowrap;background:var(--blue-lt);}
.mo-table tbody tr:hover{background:var(--blue-lt);}
.mo-table tbody td{padding:12px 16px;font-size:12.5px;border-bottom:1px solid var(--border);color:var(--text2);}
.mo-table tr.click{cursor:pointer;}
.mo-mono{font-family:monospace;font-size:12px;}
.mo-num{text-align:right;font-variant-numeric:tabular-nums;}
.mo-av{width:30px;height:30px;border-radius:50%;flex-shrink:0;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;text-transform:uppercase;}
.mo-foot{padding:14px 18px;background:#fff;border-top:1px solid var(--border);display:flex;align-items:center;justify-content:space-between;flex-wrap:wrap;gap:8px;}
.mo-foot-i{font-size:11px;color:var(--text3);}
.mo-pag{display:flex;align-items:center;gap:3px;}
.mo-pb{min-width:28px;height:28px;padding:0 6px;border-radius:5px;border:1px solid var(--border);background:#fff;font-size:11px;font-weight:600;color:var(--text2);cursor:pointer;display:flex;align-items:center;justify-content:center;}
.mo-pb:hover:not(:disabled){background:var(--bg);}
.mo-pb.active{background:var(--navy);color:#fff;border-color:var(--navy);}
.mo-pb:disabled{opacity:.35;cursor:default;}
.mo-tabs{display:flex;gap:8px;border-bottom:2px solid var(--border);padding:0 20px;overflow-x:auto;background:#fff;}
.mo-tab{padding:10px 18px;font-size:12px;font-weight:600;color:var(--text3);cursor:pointer;border:0;border-bottom:2px solid transparent;margin-bottom:-2px;background:none;white-space:nowrap;}
.mo-tab.active{color:var(--navy);border-bottom-color:var(--navy);}
.mo-tab:hover:not(.active){color:var(--text);}
.mo-form{display:grid;grid-template-columns:1fr 1fr;gap:14px 20px;padding:20px;}
.mo-form .full{grid-column:1/-1;}
.mo-form .form-group{margin-bottom:0;}
.mo-section{grid-column:1/-1;font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.6px;color:var(--text3);padding:6px 0 4px;border-bottom:1px solid var(--bg);margin-top:4px;}
.mo-section:first-child{margin-top:0;}
.mo-alert{margin:14px 20px 0;padding:10px 13px;background:var(--red-lt);color:var(--red);border-radius:8px;font-size:12.5px;}
.mo-ok{margin:14px 20px 0;padding:10px 13px;background:var(--green-lt);color:var(--green);border-radius:8px;font-size:12.5px;}
.mo-warn{margin:14px 20px 0;padding:10px 13px;background:#fff8e6;border:1px solid #f0c36d;color:#7a5b00;border-radius:8px;font-size:12.5px;}
.mo-note{padding:10px 13px;background:var(--blue-lt);color:var(--navy);border-radius:8px;font-size:12px;line-height:1.5;}
.mo-dato{font-size:13px;color:var(--text);padding:2px 0;min-height:18px;}
.mo-mxwrap{overflow:auto;max-height:420px;border:1px solid var(--border);border-radius:8px;}
.mo-mx{width:100%;border-collapse:collapse;}
.mo-mx th,.mo-mx td{padding:5px 8px;font-size:12px;border-bottom:1px solid var(--bg);}
.mo-mx th{color:var(--text3);font-weight:700;text-align:center;background:var(--surface2);position:sticky;top:0;z-index:1;}
.mo-mx td:first-child,.mo-mx th:first-child{text-align:left;position:sticky;left:0;background:#fff;min-width:210px;}
.mo-mx th:first-child{background:var(--surface2);z-index:2;}
.mo-mx td.c{text-align:center;}
.mo-mx tr.cat td{background:var(--blue-lt);font-weight:700;font-size:10.5px;text-transform:uppercase;letter-spacing:.5px;color:var(--navy);}
.mo-chk{display:inline-flex;align-items:center;gap:6px;font-size:12px;color:var(--text2);cursor:pointer;}
.mo-lin{display:flex;gap:8px;align-items:center;flex-wrap:wrap;}
.mo-panel{margin:14px 18px 0;padding:12px 14px;background:var(--amber-lt);border:1px solid #f0c36d;border-radius:8px;display:flex;gap:12px;align-items:center;flex-wrap:wrap;font-size:12.5px;color:#7a5b00;}
@media (max-width:900px){.mo-kpis{grid-template-columns:repeat(2,1fr);}}
@media (max-width:700px){.mo-form{grid-template-columns:1fr;}}
@media (max-width:520px){.mo-kpis{grid-template-columns:1fr;}}
`;

/* ── piezas comunes ──────────────────────────────────────── */
function Cab({ onVolver, titulo, sub, children }) {
  return (
    <div className="mo-head">
      <div className="mo-head-l">
        {onVolver && <button className="btn btn-sm" onClick={onVolver}>← Atrás</button>}
        <div><div className="mo-title2">{titulo}</div>{sub && <div className="mo-sub">{sub}</div>}</div>
      </div>
      <div className="mo-head-r">{children}</div>
    </div>
  );
}

function Campo({ label, req, full, children }) {
  return (
    <div className={'form-group' + (full ? ' full' : '')}>
      <label className="form-label">{label}{req && <span style={{ color: 'var(--red)' }}> *</span>}</label>
      {children}
    </div>
  );
}

function Pager({ pag, paginas, total, pagina, setPag }) {
  const desde = total === 0 ? 0 : pag * pagina + 1;
  const hasta = Math.min((pag + 1) * pagina, total);
  const nums = [];
  for (let i = Math.max(0, pag - 2); i <= Math.min(paginas - 1, pag + 2); i++) nums.push(i);
  return (
    <div className="mo-foot">
      <span className="mo-foot-i">{total > 0 ? `Mostrando ${desde} a ${hasta} de ${total.toLocaleString()} registros` : 'Sin registros'}</span>
      <div className="mo-pag">
        <button className="mo-pb" disabled={pag === 0} onClick={() => setPag(0)} title="Primera">⏮</button>
        <button className="mo-pb" disabled={pag === 0} onClick={() => setPag(pag - 1)} title="Anterior">‹</button>
        {nums.map(n => <button key={n} className={'mo-pb' + (n === pag ? ' active' : '')} onClick={() => setPag(n)}>{n + 1}</button>)}
        <button className="mo-pb" disabled={pag + 1 >= paginas} onClick={() => setPag(pag + 1)} title="Siguiente">›</button>
        <button className="mo-pb" disabled={pag + 1 >= paginas} onClick={() => setPag(paginas - 1)} title="Última">⏭</button>
      </div>
    </div>
  );
}

/* ═══════════════════════════ FORMULARIO DE EMPRESA ═══════════════════════════ */
const EMPRESA_VACIA = { RUC: '', RAZON_SOCIAL: '', NOMBRE_COMERCIAL: '', CIIU: '', ACTIVIDAD: '', DIRECCION: '', TELEFONO: '', EMAIL: '',
  CONTACTO_NOMBRE: '', CONTACTO_CARGO: '', CONTACTO_TELEFONO: '', CONTACTO_EMAIL: '', VALOR_EVALUACION: '', OBSERVACIONES: '' };

function FormEmpresa({ inicial, onVolver, onGuardado }) {
  const [f, setF] = useState(() => {
    const b = { ...EMPRESA_VACIA };
    if (inicial) Object.keys(b).forEach(k => { if (inicial[k] !== null && inicial[k] !== undefined) b[k] = inicial[k]; });
    return b;
  });
  const [err, setErr] = useState('');
  const [forzar, setForzar] = useState(false);
  const [saving, setSaving] = useState(false);
  const esNueva = !(inicial && inicial.COD);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const inp = (k, o = {}) => <input className="form-control" value={f[k] ?? ''} onChange={e => set(k, e.target.value)} {...o} />;

  const guardar = async () => {
    setErr(''); setSaving(true);
    try {
      const body = { ...f, forzar };
      if (esNueva) await api.post('/ocupacional/empresas', body);
      else await api.put(`/ocupacional/empresas/${inicial.COD}`, body);
      onGuardado();
    } catch (e) { setErr(msg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="mo-card fade-up">
      <Cab onVolver={onVolver} titulo={esNueva ? 'Nueva empresa' : 'Editar empresa'}>
        <button className="btn btn-primary btn-sm" disabled={saving} onClick={guardar}>{saving ? 'Guardando...' : '✓ Guardar'}</button>
      </Cab>
      {err && <div className="mo-alert">{err}</div>}
      {/RUC|13 d[ií]gitos|verificador/i.test(err) && (
        <div className="mo-warn">
          <label className="mo-chk"><input type="checkbox" checked={forzar} onChange={e => setForzar(e.target.checked)} />
            Guardar de todas formas (RUC que el sistema no puede verificar). Solo vale si tiene 13 dígitos.</label>
        </div>
      )}
      <div className="mo-form">
        <div className="mo-section">Identificación</div>
        <Campo label="RUC" req>{inp('RUC', { maxLength: 13, inputMode: 'numeric', placeholder: 'Ej: 1790010937001' })}</Campo>
        <Campo label="Razón social" req>{inp('RAZON_SOCIAL')}</Campo>
        <Campo label="Nombre comercial">{inp('NOMBRE_COMERCIAL')}</Campo>
        <Campo label="CIIU">{inp('CIIU', { placeholder: 'Ej: Q8610.01' })}</Campo>
        <Campo label="Actividad económica" full>{inp('ACTIVIDAD')}</Campo>

        <div className="mo-section">Ubicación y contacto</div>
        <Campo label="Dirección" full>{inp('DIRECCION')}</Campo>
        <Campo label="Teléfono">{inp('TELEFONO')}</Campo>
        <Campo label="Correo">{inp('EMAIL', { type: 'email' })}</Campo>
        <Campo label="Contacto (Talento Humano)">{inp('CONTACTO_NOMBRE')}</Campo>
        <Campo label="Cargo del contacto">{inp('CONTACTO_CARGO')}</Campo>
        <Campo label="Teléfono del contacto">{inp('CONTACTO_TELEFONO')}</Campo>
        <Campo label="Correo del contacto">{inp('CONTACTO_EMAIL', { type: 'email' })}</Campo>

        <div className="mo-section">Condiciones</div>
        <Campo label="Valor por evaluación (USD)">{inp('VALOR_EVALUACION', { type: 'number', min: 0, step: '0.01' })}</Campo>
        <div />
        <Campo label="Observaciones" full>
          <textarea className="form-control" value={f.OBSERVACIONES ?? ''} onChange={e => set('OBSERVACIONES', e.target.value)} />
        </Campo>
      </div>
    </div>
  );
}

/* ═══════════════════════════ EDITOR DE PUESTO ═══════════════════════════ */
function EditorPuesto({ empresa, inicial, onVolver, onGuardado }) {
  const [f, setF] = useState(() => ({
    NOMBRE: inicial ? inicial.NOMBRE : '', CIUO: inicial ? inicial.CIUO || '' : '', AREA: inicial ? inicial.AREA || '' : '',
    ACTIVIDADES: Array.from({ length: 7 }, (_, i) => (inicial && inicial.ACTIVIDADES && inicial.ACTIVIDADES[i]) || ''),
    RIESGOS: (inicial && inicial.RIESGOS) || {}, MEDIDAS_PREVENTIVAS: inicial ? inicial.MEDIDAS_PREVENTIVAS || '' : '',
  }));
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const esNuevo = !(inicial && inicial.COD);
  const toggle = (clave, col) => setF(p => {
    const r = { ...p.RIESGOS }; const fila = { ...(r[clave] || {}) };
    if (fila[col]) delete fila[col]; else fila[col] = true;
    if (Object.keys(fila).length) r[clave] = fila; else delete r[clave];
    return { ...p, RIESGOS: r };
  });
  const totalMarcas = Object.values(f.RIESGOS).reduce((s, x) => s + Object.keys(x).length, 0);

  const guardar = async () => {
    setErr(''); setSaving(true);
    try {
      const body = { ...f, COD_EMPRESA: empresa.COD };
      if (esNuevo) await api.post('/ocupacional/puestos', body);
      else await api.put(`/ocupacional/puestos/${inicial.COD}`, body);
      onGuardado();
    } catch (e) { setErr(msg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="mo-card fade-up">
      <Cab onVolver={onVolver} titulo={esNuevo ? 'Nuevo puesto' : `Puesto: ${inicial.NOMBRE}`} sub={empresa.RAZON_SOCIAL}>
        <button className="btn btn-primary btn-sm" disabled={saving} onClick={guardar}>{saving ? 'Guardando...' : '✓ Guardar puesto'}</button>
      </Cab>
      {err && <div className="mo-alert">{err}</div>}
      <div style={{ padding: '14px 20px 0' }}>
        <div className="mo-note">Las actividades y los factores de riesgo llegan precargados al bloque G del FEMO de cada trabajador que ocupe este puesto. El médico solo corrige lo que cambió.</div>
      </div>
      <div className="mo-form">
        <div className="mo-section">Datos del puesto</div>
        <Campo label="Nombre del puesto" req full><input className="form-control" value={f.NOMBRE} onChange={e => setF({ ...f, NOMBRE: e.target.value })} placeholder="Ej: Enfermera" /></Campo>
        <Campo label="Código CIUO"><input className="form-control" value={f.CIUO} onChange={e => setF({ ...f, CIUO: e.target.value })} placeholder="Ej: 2221.01.02" /></Campo>
        <Campo label="Área"><input className="form-control" value={f.AREA} onChange={e => setF({ ...f, AREA: e.target.value })} /></Campo>

        <div className="mo-section">Actividades importantes de la jornada (hasta 7; no hace falta llenar todas)</div>
        {f.ACTIVIDADES.map((a, i) => (
          <Campo key={i} label={`Actividad ${i + 1}`}>
            <input className="form-control" value={a}
              onChange={e => setF(p => ({ ...p, ACTIVIDADES: p.ACTIVIDADES.map((x, j) => (j === i ? e.target.value : x)) }))} />
          </Campo>
        ))}

        <div className="mo-section">Factores de riesgo por actividad · {totalMarcas} marca{totalMarcas === 1 ? '' : 's'}</div>
        <div className="full mo-mxwrap">
          <table className="mo-mx">
            <thead><tr><th>Factor de riesgo</th>{[0, 1, 2, 3, 4, 5, 6].map(c => <th key={c} title={f.ACTIVIDADES[c] || ''}>{c + 1}</th>)}</tr></thead>
            <tbody>
              {RIESGOS.map(([cat, pre, items]) => [
                <tr key={pre} className="cat"><td colSpan={8}>{cat}</td></tr>,
                ...items.map((it, i) => (
                  <tr key={pre + i}><td>{it}</td>
                    {[0, 1, 2, 3, 4, 5, 6].map(c => (
                      <td key={c} className="c"><input type="checkbox" aria-label={`${it}, actividad ${c + 1}`}
                        checked={!!(f.RIESGOS[pre + i] && f.RIESGOS[pre + i][c])} onChange={() => toggle(pre + i, c)} /></td>
                    ))}</tr>
                )),
              ])}
            </tbody>
          </table>
        </div>

        <div className="mo-section">Medidas preventivas</div>
        <Campo label="Medidas preventivas" full>
          <textarea className="form-control" value={f.MEDIDAS_PREVENTIVAS} onChange={e => setF({ ...f, MEDIDAS_PREVENTIVAS: e.target.value })} placeholder="EPP, capacitación, pausas activas..." />
        </Campo>
      </div>
    </div>
  );
}

/* ═══════════════════════════ PESTAÑA PUESTOS ═══════════════════════════ */
function TabPuestos({ empresa, onEditar }) {
  const [rows, setRows] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [err, setErr] = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    try { const { data } = await api.get(`/ocupacional/puestos?empresa=${empresa.COD}`); setRows(data); setErr(''); }
    catch (e) { setErr(msg(e)); } finally { setCargando(false); }
  }, [empresa.COD]);
  useEffect(() => { cargar(); }, [cargar]);

  const quitar = async p => {
    if (!window.confirm(`¿Quitar el puesto «${p.NOMBRE}»?`)) return;
    try { await api.delete(`/ocupacional/puestos/${p.COD}`); cargar(); } catch (e) { setErr(msg(e)); }
  };

  return (
    <div>
      <div className="mo-toolbar">
        <span className="mo-foot-i" style={{ flex: 1 }}>Un puesto se define una sola vez; sus riesgos se reutilizan en cada evaluación.</span>
        <button className="btn btn-primary btn-sm" onClick={() => onEditar(null)}>+ Nuevo puesto</button>
      </div>
      {err && <div className="mo-alert" style={{ marginBottom: 14 }}>{err}</div>}
      <div className="table-wrap">
        <table className="mo-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th>Puesto</th><th>CIUO</th><th>Área</th><th>Actividades</th><th>Riesgos</th><th>Trabajadores</th><th style={{ width: 90, textAlign: 'center' }}>Acción</th></tr></thead>
          <tbody>
            {cargando ? <tr><td colSpan={7} style={{ textAlign: 'center', padding: '32px 0' }}><div className="spinner" style={{ margin: '0 auto' }} /></td></tr>
              : rows.length === 0 ? <tr><td colSpan={7}><div className="empty-state">Esta empresa todavía no tiene puestos. Cree el primero o impórtelos junto con la nómina.</div></td></tr>
              : rows.map(p => {
                const nAct = (p.ACTIVIDADES || []).filter(Boolean).length;
                const nRie = Object.keys(p.RIESGOS || {}).length;
                return (
                  <tr key={p.COD} className="click" onClick={() => onEditar(p)}>
                    <td style={{ fontWeight: 600, color: 'var(--navy)' }}>{p.NOMBRE}</td>
                    <td className="mo-mono">{p.CIUO || '—'}</td><td>{p.AREA || '—'}</td>
                    <td>{nAct || <span className="badge badge-amber">Sin definir</span>}</td>
                    <td>{nRie || <span className="badge badge-amber">Sin definir</span>}</td>
                    <td>{p.N_TRABAJADORES}</td>
                    <td style={{ textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                      <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                        <div className="act-icon" title="Editar" onClick={() => onEditar(p)}>✎</div>
                        <div className="act-icon" title="Quitar" onClick={() => quitar(p)} style={{ color: 'var(--red)' }}>✕</div>
                      </div>
                    </td>
                  </tr>);
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ═══════════════════════════ FORMULARIO DE TRABAJADOR ═══════════════════════════ */
function FormTrabajador({ empresa, inicial, onVolver, onGuardado }) {
  const [puestos, setPuestos] = useState([]);
  const [f, setF] = useState({ IDENTIFICACION: '', APELLIDOS: '', NOMBRES: '', SEXO: '', FECHA_NACIMIENTO: '', FECHA_INGRESO: '', COD_PUESTO: '', EMAIL: '', TELEFONO: '',
    ...(inicial ? { ...inicial, COD_PUESTO: inicial.COD_PUESTO || '', SEXO: inicial.SEXO || '', EMAIL: inicial.EMAIL || '', TELEFONO: inicial.TELEFONO || '',
      FECHA_NACIMIENTO: (inicial.FECHA_NACIMIENTO || '').slice(0, 10), FECHA_INGRESO: (inicial.FECHA_INGRESO || '').slice(0, 10) } : {}) });
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);
  const esNuevo = !(inicial && inicial.COD);
  const set = (k, v) => setF(p => ({ ...p, [k]: v }));

  useEffect(() => {
    api.get(`/ocupacional/puestos?empresa=${empresa.COD}`).then(r => setPuestos(r.data)).catch(() => { /* el guardado informará */ });
  }, [empresa.COD]);

  const guardar = async () => {
    setErr(''); setSaving(true);
    try {
      const body = { ...f, COD_EMPRESA: empresa.COD, COD_PUESTO: f.COD_PUESTO || null };
      if (esNuevo) await api.post('/ocupacional/trabajadores', body);
      else await api.put(`/ocupacional/trabajadores/${inicial.COD}`, body);
      onGuardado();
    } catch (e) { setErr(msg(e)); } finally { setSaving(false); }
  };

  return (
    <div className="mo-card fade-up">
      <Cab onVolver={onVolver} titulo={esNuevo ? 'Nuevo trabajador' : 'Editar trabajador'} sub={empresa.RAZON_SOCIAL}>
        <button className="btn btn-primary btn-sm" disabled={saving} onClick={guardar}>{saving ? 'Guardando...' : '✓ Guardar'}</button>
      </Cab>
      {err && <div className="mo-alert">{err}</div>}
      <div className="mo-form">
        <div className="mo-section">Identificación</div>
        <Campo label="Cédula" req><input className="form-control" value={f.IDENTIFICACION} maxLength={10} inputMode="numeric" placeholder="Ej: 1712345678" onChange={e => set('IDENTIFICACION', e.target.value)} /></Campo>
        <Campo label="Sexo (según cédula)"><select className="form-control" value={f.SEXO} onChange={e => set('SEXO', e.target.value)}>
          <option value="">Sin dato</option><option value="H">Hombre</option><option value="M">Mujer</option></select></Campo>
        <Campo label="Apellidos" req><input className="form-control" value={f.APELLIDOS} onChange={e => set('APELLIDOS', e.target.value)} /></Campo>
        <Campo label="Nombres" req><input className="form-control" value={f.NOMBRES} onChange={e => set('NOMBRES', e.target.value)} /></Campo>
        <Campo label="Fecha de nacimiento"><input className="form-control" type="date" value={f.FECHA_NACIMIENTO} onChange={e => set('FECHA_NACIMIENTO', e.target.value)} /></Campo>
        <div />
        <div className="mo-section">Trabajo</div>
        <Campo label="Puesto"><select className="form-control" value={f.COD_PUESTO} onChange={e => set('COD_PUESTO', e.target.value)}>
          <option value="">Sin puesto</option>{puestos.map(p => <option key={p.COD} value={p.COD}>{p.NOMBRE}</option>)}</select></Campo>
        <Campo label="Fecha de ingreso"><input className="form-control" type="date" value={f.FECHA_INGRESO} onChange={e => set('FECHA_INGRESO', e.target.value)} /></Campo>
        <div className="mo-section">Contacto</div>
        <Campo label="Correo"><input className="form-control" type="email" value={f.EMAIL} onChange={e => set('EMAIL', e.target.value)} /></Campo>
        <Campo label="Teléfono"><input className="form-control" value={f.TELEFONO} onChange={e => set('TELEFONO', e.target.value)} /></Campo>
      </div>
    </div>
  );
}

/* ═══════════════════════════ IMPORTAR NÓMINA ═══════════════════════════ */
const BADGE_IMPORT = { error: 'badge-red', nuevo: 'badge-green', actualiza: 'badge-blue', existe: 'badge-gray', pendiente: 'badge-gray' };

function Importar({ empresa, onVolver, onHecho }) {
  const [texto, setTexto] = useState('');
  const [opts, setOpts] = useState({ crear_puestos: true, actualizar: false, ignorar_errores: false });
  const [sim, setSim] = useState(null);
  const [err, setErr] = useState('');
  const [trabajando, setTrabajando] = useState(false);
  const [hecho, setHecho] = useState(null);
  const parsed = parsearNomina(texto);

  const cargarArchivo = e => {
    const file = e.target.files && e.target.files[0]; if (!file) return;
    const r = new FileReader();
    r.onload = () => { setTexto(String(r.result || '')); setSim(null); };
    r.readAsText(file, 'utf-8');
  };
  const llamar = async confirmar => {
    setErr(''); setTrabajando(true);
    try {
      const { data } = await api.post('/ocupacional/trabajadores/importar', { empresa: empresa.COD, filas: parsed.filas, ...opts, confirmar });
      if (confirmar) setHecho(data.resumen); else setSim(data);
    } catch (e) {
      setErr(msg(e));
      const d = e && e.response && e.response.data; if (d && d.detalle) setSim(d);
    } finally { setTrabajando(false); }
  };
  const cambiaOpt = (k, v) => { setOpts(o => ({ ...o, [k]: v })); if (k !== 'ignorar_errores') setSim(null); };

  const r = sim && sim.resumen;
  const puedeImportar = !!sim && !!sim.simulacion && !trabajando && !(r && r.errores > 0 && !opts.ignorar_errores) && !(r && r.nuevos + r.actualizan === 0);

  return (
    <div className="mo-card fade-up">
      <Cab onVolver={hecho ? onHecho : onVolver} titulo="Importar nómina" sub={empresa.RAZON_SOCIAL}>
        {!hecho && <>
          <button className="btn btn-sm" disabled={!parsed.filas.length || trabajando} onClick={() => llamar(false)}>Revisar</button>
          <button className="btn btn-primary btn-sm" disabled={!puedeImportar} onClick={() => llamar(true)}>{trabajando ? 'Procesando...' : '✓ Importar'}</button>
        </>}
      </Cab>
      {err && <div className="mo-alert">{err}</div>}
      {hecho ? (
        <div style={{ padding: 20 }}>
          <div className="mo-ok" style={{ margin: 0 }}><b>Importación terminada.</b> Nuevos: {hecho.nuevos} · Actualizados: {hecho.actualizan} · Omitidos: {hecho.existentes} · Con error: {hecho.errores}
            {hecho.puestos_nuevos.length > 0 && <> · Puestos creados: {hecho.puestos_nuevos.join(', ')} (complete sus riesgos en la pestaña Puestos)</>}</div>
          <div style={{ marginTop: 14 }}><button className="btn btn-primary btn-sm" onClick={onHecho}>Listo</button></div>
        </div>
      ) : (
        <div className="mo-form">
          <div className="mo-section">Datos</div>
          <div className="full mo-note">Copie las celdas desde Excel y péguelas aquí, o cargue un archivo CSV. Con encabezados se reconocen: cédula, apellidos, nombres, puesto, sexo, fecha de nacimiento, fecha de ingreso, correo y teléfono.
            Sin encabezados el orden es: {ORDEN_DEFECTO.join(', ').replace(/_/g, ' ')}.</div>
          <div className="full mo-lin">
            <input type="file" accept=".csv,.txt,text/csv,text/plain" onChange={cargarArchivo} style={{ fontSize: 12 }} />
            <span className="mo-foot-i">{parsed.filas.length} fila{parsed.filas.length === 1 ? '' : 's'} detectada{parsed.filas.length === 1 ? '' : 's'}{parsed.conEncabezado ? ' (con encabezados)' : ''}</span>
          </div>
          <div className="full">
            <textarea className="form-control" style={{ minHeight: 140, fontFamily: 'monospace' }} value={texto} placeholder="Pegue aquí la nómina..."
              onChange={e => { setTexto(e.target.value); setSim(null); }} />
          </div>
          <div className="mo-section">Opciones</div>
          <div className="full mo-lin" style={{ gap: 20 }}>
            <label className="mo-chk"><input type="checkbox" checked={opts.crear_puestos} onChange={e => cambiaOpt('crear_puestos', e.target.checked)} /> Crear los puestos que no existan</label>
            <label className="mo-chk"><input type="checkbox" checked={opts.actualizar} onChange={e => cambiaOpt('actualizar', e.target.checked)} /> Actualizar a los que ya están</label>
            <label className="mo-chk"><input type="checkbox" checked={opts.ignorar_errores} onChange={e => cambiaOpt('ignorar_errores', e.target.checked)} /> Importar omitiendo las filas con error</label>
          </div>
          {r && (<>
            <div className="mo-section">Resultado de la revisión (todavía no se guardó nada)</div>
            <div className="full mo-lin">
              <span className="badge badge-green">Nuevos {r.nuevos}</span>
              {r.actualizan > 0 && <span className="badge badge-blue">Se actualizan {r.actualizan}</span>}
              <span className="badge badge-gray">Ya existen {r.existentes}</span>
              <span className={'badge ' + (r.errores ? 'badge-red' : 'badge-gray')}>Errores {r.errores}</span>
              {r.puestos_nuevos.length > 0 && <span className="badge badge-amber">Puestos nuevos: {r.puestos_nuevos.join(', ')}</span>}
            </div>
            {sim.detalle.some(d => d.estado !== 'nuevo' || d.mensaje) && (
              <div className="full table-wrap" style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 8 }}>
                <table className="mo-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead><tr><th>Fila</th><th>Cédula</th><th>Estado</th><th>Detalle</th></tr></thead>
                  <tbody>{sim.detalle.filter(d => d.estado !== 'nuevo' || d.mensaje).map(d => (
                    <tr key={d.linea}><td>{d.linea}</td><td className="mo-mono">{d.cedula || '—'}</td>
                      <td><span className={'badge ' + (BADGE_IMPORT[d.estado] || 'badge-gray')}>{d.estado}</span></td><td>{d.mensaje}</td></tr>))}</tbody>
                </table>
              </div>)}
          </>)}
        </div>
      )}
    </div>
  );
}

/* ═══════════════════════════ PESTAÑA NÓMINA ═══════════════════════════ */
const PAGINA = 25;
function TabNomina({ empresa, onEditar, onImportar }) {
  const [q, setQ] = useState('');
  const [puesto, setPuesto] = useState('');
  const [activo, setActivo] = useState('1');
  const [pag, setPag] = useState(0);
  const [data, setData] = useState({ total: 0, rows: [] });
  const [puestos, setPuestos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [err, setErr] = useState('');
  const [salida, setSalida] = useState(null);   // { t, fecha, res, err }

  useEffect(() => {
    api.get(`/ocupacional/puestos?empresa=${empresa.COD}`).then(r => setPuestos(r.data)).catch(() => { /* la lista informa */ });
  }, [empresa.COD]);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const p = new URLSearchParams({ empresa: empresa.COD, activo, limit: PAGINA, offset: pag * PAGINA });
      if (q.trim()) p.set('q', q.trim());
      if (puesto) p.set('puesto', puesto);
      const { data: d } = await api.get(`/ocupacional/trabajadores?${p.toString()}`);
      setData(d); setErr('');
    } catch (e) { setErr(msg(e)); } finally { setCargando(false); }
  }, [empresa.COD, q, puesto, activo, pag]);
  useEffect(() => { const t = setTimeout(cargar, 250); return () => clearTimeout(t); }, [cargar]);

  const reactivar = async t => {
    try { await api.put(`/ocupacional/trabajadores/${t.COD}`, { ...t, COD_EMPRESA: empresa.COD, ACTIVO: 1 }); cargar(); } catch (e) { setErr(msg(e)); }
  };
  const registrarSalida = async () => {
    setSalida(s => ({ ...s, err: '' }));
    try {
      const { data: d } = await api.post(`/ocupacional/trabajadores/${salida.t.COD}/salida`, { fecha: salida.fecha });
      setSalida(s => ({ ...s, res: d }));
    } catch (e) { setSalida(s => ({ ...s, err: msg(e) })); }
  };
  const cerrarSalida = () => { const hizo = salida && salida.res; setSalida(null); if (hizo) cargar(); };
  const paginas = Math.max(1, Math.ceil(data.total / PAGINA));

  return (
    <div>
      <div className="mo-toolbar">
        <div className="search-wrap" style={{ flex: '1 1 220px', maxWidth: 380, position: 'relative' }}>
          <span className="search-icon" style={{ fontSize: 13 }}>⊙</span>
          <input className="form-control" placeholder="Buscar por cédula, apellido o nombre..." value={q} onChange={e => { setQ(e.target.value); setPag(0); }} />
        </div>
        <select className="form-control" style={{ width: 'auto', maxWidth: 220 }} value={puesto} onChange={e => { setPuesto(e.target.value); setPag(0); }} aria-label="Filtrar por puesto">
          <option value="">Todos los puestos</option>{puestos.map(p => <option key={p.COD} value={p.COD}>{p.NOMBRE}</option>)}</select>
        <select className="form-control" style={{ width: 'auto' }} value={activo} onChange={e => { setActivo(e.target.value); setPag(0); }} aria-label="Estado">
          <option value="1">Activos</option><option value="0">Inactivos</option><option value="todos">Todos</option></select>
        <span style={{ flex: 1 }} />
        <button className="btn btn-sm" onClick={onImportar}>Importar nómina</button>
        <button className="btn btn-primary btn-sm" onClick={() => onEditar(null)}>+ Trabajador</button>
      </div>
      {err && <div className="mo-alert" style={{ marginBottom: 14 }}>{err}</div>}
      {salida && (
        <div className="mo-panel">
          {salida.res ? (<>
            <span>Salida de <b>{salida.t.APELLIDOS} {salida.t.NOMBRES}</b> registrada el {fmtFecha(salida.res.fecha_salida)}. La evaluación de retiro debe hacerse hasta el <b>{fmtFecha(salida.res.retiro_limite)}</b> (plazo de 5 días tomado de fuentes secundarias del SISAT; confirmar con el texto oficial).</span>
            <button className="btn btn-sm" onClick={cerrarSalida}>Listo</button>
          </>) : (<>
            <span>Salida de <b>{salida.t.APELLIDOS} {salida.t.NOMBRES}</b> · último día de trabajo:</span>
            <input className="form-control" type="date" style={{ width: 160 }} value={salida.fecha} onChange={e => setSalida({ ...salida, fecha: e.target.value })} />
            <button className="btn btn-primary btn-sm" onClick={registrarSalida}>Registrar salida</button>
            <button className="btn btn-sm" onClick={() => setSalida(null)}>Cancelar</button>
            {salida.err && <span style={{ color: 'var(--red)', fontWeight: 600 }}>{salida.err}</span>}
          </>)}
        </div>
      )}
      <div className="table-wrap" style={{ marginTop: salida ? 14 : 0 }}>
        <table className="mo-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr><th style={{ width: 130 }}>Cédula</th><th>Trabajador</th><th>Puesto</th><th>Ingreso</th><th>Estado</th><th style={{ width: 100, textAlign: 'center' }}>Acción</th></tr></thead>
          <tbody>
            {cargando && data.rows.length === 0 ? <tr><td colSpan={6} style={{ textAlign: 'center', padding: '32px 0' }}><div className="spinner" style={{ margin: '0 auto' }} /></td></tr>
              : data.rows.length === 0 ? <tr><td colSpan={6}><div className="empty-state">No hay trabajadores con estos filtros. Importe la nómina de la empresa o agréguelos uno por uno.</div></td></tr>
              : data.rows.map(t => (
                <tr key={t.COD} className="click" onClick={() => onEditar(t)}>
                  <td className="mo-mono" style={{ fontWeight: 600, color: 'var(--navy)' }}>{t.IDENTIFICACION}</td>
                  <td>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 9 }}>
                      <div className="mo-av" style={{ background: t.SEXO === 'M' ? '#fbeaf5' : 'var(--blue-lt)', color: t.SEXO === 'M' ? '#993556' : 'var(--navy)' }}>{iniciales(t.NOMBRES, t.APELLIDOS)}</div>
                      <div style={{ fontWeight: 500 }}>{t.APELLIDOS} {t.NOMBRES}</div>
                    </div>
                  </td>
                  <td>{t.PUESTO_NOMBRE || <span className="badge badge-amber">Sin puesto</span>}</td>
                  <td>{fmtFecha(t.FECHA_INGRESO)}</td>
                  <td>{t.ACTIVO ? <span className="badge badge-green">Activo</span> : <span className="badge badge-gray">Salió {fmtFecha(t.FECHA_SALIDA)}</span>}</td>
                  <td style={{ textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                    <div style={{ display: 'flex', gap: 4, justifyContent: 'center' }}>
                      <div className="act-icon" title="Editar" onClick={() => onEditar(t)}>✎</div>
                      {t.ACTIVO
                        ? <div className="act-icon" title="Registrar salida" onClick={() => setSalida({ t, fecha: hoyISO(), res: null, err: '' })}>⇥</div>
                        : <div className="act-icon" title="Reactivar" onClick={() => reactivar(t)}>↺</div>}
                    </div>
                  </td>
                </tr>))}
          </tbody>
        </table>
      </div>
      <Pager pag={pag} paginas={paginas} total={data.total} pagina={PAGINA} setPag={setPag} />
    </div>
  );
}

/* ═══════════════════════════ DETALLE DE EMPRESA ═══════════════════════════ */
function DetalleEmpresa({ id, onVolver }) {
  const [emp, setEmp] = useState(null);
  const [tab, setTab] = useState('datos');
  const [sub, setSub] = useState(null);   // null | {t:'editar'} | {t:'puesto',p} | {t:'trab',tr} | {t:'importar'}
  const [err, setErr] = useState('');

  const cargar = useCallback(async () => {
    try { const { data } = await api.get(`/ocupacional/empresas/${id}`); setEmp(data); setErr(''); } catch (e) { setErr(msg(e)); }
  }, [id]);
  useEffect(() => { cargar(); }, [cargar]);

  const volver = () => { setSub(null); cargar(); };

  const cambiarEstado = async () => {
    const activar = !emp.ACTIVO;
    if (!activar && !window.confirm(`¿Desactivar a ${emp.RAZON_SOCIAL}? No se borra nada; deja de aparecer en la lista.`)) return;
    try {
      if (activar) await api.put(`/ocupacional/empresas/${emp.COD}`, { ...emp, ACTIVO: 1 });
      else await api.delete(`/ocupacional/empresas/${emp.COD}`);
      cargar();
    } catch (e) { setErr(msg(e)); }
  };

  if (!emp) return (
    <div className="mo-card"><Cab onVolver={onVolver} titulo="Empresa" />
      {err ? <div className="mo-alert" style={{ marginBottom: 14 }}>{err}</div> : <div className="spinner" />}</div>);

  if (sub && sub.t === 'editar') return <FormEmpresa inicial={emp} onVolver={() => setSub(null)} onGuardado={volver} />;
  if (sub && sub.t === 'puesto') return <EditorPuesto empresa={emp} inicial={sub.p} onVolver={() => setSub(null)} onGuardado={volver} />;
  if (sub && sub.t === 'trab') return <FormTrabajador empresa={emp} inicial={sub.tr} onVolver={() => setSub(null)} onGuardado={volver} />;
  if (sub && sub.t === 'importar') return <Importar empresa={emp} onVolver={() => setSub(null)} onHecho={volver} />;

  const dato = (l, v) => <Campo label={l}><div className="mo-dato">{v || '—'}</div></Campo>;
  return (
    <div className="mo-card fade-up">
      <Cab onVolver={onVolver} titulo={emp.RAZON_SOCIAL}
        sub={<>RUC {emp.RUC} · {emp.N_TRABAJADORES} trabajadores · {emp.N_PUESTOS} puestos</>}>
        {emp.CATEGORIA_SISAT && <span className="badge badge-blue" title="Referencial: sale del número de trabajadores; confirmar con el texto oficial del SISAT">Categoría {emp.CATEGORIA_SISAT} (ref.)</span>}
        {emp.ACTIVO ? <span className="badge badge-green">Activa</span> : <span className="badge badge-gray">Inactiva</span>}
      </Cab>
      <div className="mo-tabs" role="tablist">
        {[['datos', 'Datos'], ['puestos', `Puestos (${emp.N_PUESTOS})`], ['nomina', `Nómina (${emp.N_TRABAJADORES})`]].map(([k, t]) => (
          <button key={k} role="tab" aria-selected={tab === k} className={'mo-tab' + (tab === k ? ' active' : '')} onClick={() => setTab(k)}>{t}</button>))}
      </div>
      {err && <div className="mo-alert" style={{ marginBottom: 14 }}>{err}</div>}
      {tab === 'datos' && (
        <>
          <div className="mo-form">
            <div className="mo-section">Identificación</div>
            {dato('Nombre comercial', emp.NOMBRE_COMERCIAL)}{dato('CIIU', emp.CIIU)}{dato('Actividad económica', emp.ACTIVIDAD)}<div />
            <div className="mo-section">Ubicación y contacto</div>
            {dato('Dirección', emp.DIRECCION)}{dato('Teléfono', emp.TELEFONO)}{dato('Correo', emp.EMAIL)}
            {dato('Contacto', [emp.CONTACTO_NOMBRE, emp.CONTACTO_CARGO].filter(Boolean).join(' · '))}
            {dato('Teléfono del contacto', emp.CONTACTO_TELEFONO)}{dato('Correo del contacto', emp.CONTACTO_EMAIL)}
            <div className="mo-section">Condiciones</div>
            {dato('Valor por evaluación', fmtMoney(emp.VALOR_EVALUACION))}{dato('Observaciones', emp.OBSERVACIONES)}
          </div>
          <div className="mo-foot" style={{ justifyContent: 'flex-start', gap: 8 }}>
            <button className="btn btn-primary btn-sm" onClick={() => setSub({ t: 'editar' })}>✎ Editar datos</button>
            <button className="btn btn-sm" onClick={cambiarEstado} style={emp.ACTIVO ? { color: 'var(--red)', borderColor: 'var(--red)' } : undefined}>
              {emp.ACTIVO ? 'Desactivar empresa' : 'Reactivar empresa'}</button>
          </div>
        </>)}
      {tab === 'puestos' && <TabPuestos empresa={emp} onEditar={p => setSub({ t: 'puesto', p })} />}
      {tab === 'nomina' && <TabNomina empresa={emp} onEditar={tr => setSub({ t: 'trab', tr })} onImportar={() => setSub({ t: 'importar' })} />}
    </div>
  );
}

/* ═══════════════════════════ LISTA DE EMPRESAS ═══════════════════════════ */
function ListaEmpresas({ onAbrir, onNueva }) {
  const [rows, setRows] = useState([]);
  const [kpis, setKpis] = useState(null);
  const [q, setQ] = useState('');
  const [verInactivas, setVerInactivas] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [err, setErr] = useState('');

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const p = new URLSearchParams({ activo: verInactivas ? 'todos' : '1' });
      if (q.trim()) p.set('q', q.trim());
      const [lista, k] = await Promise.all([api.get(`/ocupacional/empresas?${p.toString()}`), api.get('/ocupacional/kpis')]);
      setRows(lista.data); setKpis(k.data); setErr('');
    } catch (e) { setErr(msg(e)); } finally { setCargando(false); }
  }, [q, verInactivas]);
  useEffect(() => { const t = setTimeout(cargar, 250); return () => clearTimeout(t); }, [cargar]);

  const kpi = (l, v, s) => (
    <div className="mo-kpi"><div className="mo-kpi-l">{l}</div><div className="mo-kpi-v">{v === null || v === undefined ? '—' : Number(v).toLocaleString()}</div><div className="mo-kpi-s">{s}</div></div>);

  return (
    <>
      <div className="mo-kpis">
        {kpi('Empresas activas', kpis && kpis.empresas, 'clientes de medicina ocupacional')}
        {kpi('Trabajadores en nómina', kpis && kpis.trabajadores, 'activos en todas las empresas')}
        {kpi('Puestos definidos', kpis && kpis.puestos, 'con su matriz de riesgos')}
      </div>
      <div className="mo-card fade-up">
        <div className="mo-head">
          <span className="mo-title">Empresas</span>
          <button className="btn btn-sm" style={{ background: 'var(--navy)', color: '#fff', border: 'none', fontWeight: 700 }} onClick={onNueva}>+ Nueva empresa</button>
        </div>
        <div className="mo-toolbar">
          <div className="search-wrap" style={{ flex: '1 1 220px', maxWidth: 420, position: 'relative' }}>
            <span className="search-icon" style={{ fontSize: 13 }}>⊙</span>
            <input className="form-control" placeholder="Buscar por razón social o RUC..." value={q} onChange={e => setQ(e.target.value)} />
          </div>
          <label className="mo-chk"><input type="checkbox" checked={verInactivas} onChange={e => setVerInactivas(e.target.checked)} /> Mostrar inactivas</label>
        </div>
        {err && <div className="mo-alert" style={{ marginBottom: 14 }}>{err}</div>}
        <div className="table-wrap">
          <table className="mo-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead><tr><th>Empresa</th><th className="hide-mobile">Actividad</th><th>Trabajadores</th><th className="hide-mobile">Puestos</th><th className="hide-mobile" title="Referencial">Cat. SISAT</th><th className="hide-mobile">Valor eval.</th><th>Estado</th></tr></thead>
            <tbody>
              {cargando && rows.length === 0 ? <tr><td colSpan={7} style={{ textAlign: 'center', padding: '32px 0' }}><div className="spinner" style={{ margin: '0 auto' }} /></td></tr>
                : rows.length === 0 ? <tr><td colSpan={7}><div className="empty-state">Todavía no hay empresas. Registre la primera con «+ Nueva empresa».</div></td></tr>
                : rows.map(e => (
                  <tr key={e.COD} className="click" onClick={() => onAbrir(e.COD)}>
                    <td><div style={{ fontWeight: 600, color: 'var(--navy)' }}>{e.RAZON_SOCIAL}</div><div className="mo-sub mo-mono">{e.RUC}</div></td>
                    <td className="hide-mobile">{e.ACTIVIDAD || '—'}{e.CIIU && <div className="mo-sub mo-mono">{e.CIIU}</div>}</td>
                    <td>{e.N_TRABAJADORES}</td><td className="hide-mobile">{e.N_PUESTOS}</td>
                    <td className="hide-mobile">{e.CATEGORIA_SISAT ? <span className="badge badge-blue">{e.CATEGORIA_SISAT}</span> : '—'}</td>
                    <td className="hide-mobile">{fmtMoney(e.VALOR_EVALUACION)}</td>
                    <td>{e.ACTIVO ? <span className="badge badge-green">Activa</span> : <span className="badge badge-gray">Inactiva</span>}</td>
                  </tr>))}
            </tbody>
          </table>
        </div>
        <div className="mo-foot"><span className="mo-foot-i">{rows.length} empresa{rows.length === 1 ? '' : 's'}</span></div>
      </div>
    </>
  );
}

/* ═══════════════════════════ PÁGINA ═══════════════════════════ */
export default function Empresas() {
  const [vista, setVista] = useState({ t: 'lista' });   // lista | nueva | detalle
  return (
    <>
      <style>{css}</style>
      <div className="fade-up">
        {vista.t === 'lista' && <ListaEmpresas onAbrir={id => setVista({ t: 'detalle', id })} onNueva={() => setVista({ t: 'nueva' })} />}
        {vista.t === 'nueva' && <FormEmpresa onVolver={() => setVista({ t: 'lista' })} onGuardado={() => setVista({ t: 'lista' })} />}
        {vista.t === 'detalle' && <DetalleEmpresa id={vista.id} onVolver={() => setVista({ t: 'lista' })} />}
      </div>
    </>
  );
}
